import { ArrowRight } from "lucide-react";
import { CTA_CONFIG } from "@/lib/cta";

// Swappable enquiry/booking CTA. Keeps identical geometry in both modes so the
// design requirement (swap Enquire -> Book Now with no layout change) holds.
export default function CtaButton({
  onEnquire,
  className = "",
  size = "lg",
  full = false,
  label: labelOverride,
  testId = "cta-button",
}) {
  const isBook = CTA_CONFIG.mode === "book";
  const label = labelOverride || (isBook ? CTA_CONFIG.bookLabel : CTA_CONFIG.enquireLabel);

  const base =
    "group inline-flex items-center justify-center gap-2.5 rounded-full bg-terracotta text-white font-sans font-bold shadow-md hover:bg-terracottahover hover:shadow-glowwarm hover:scale-[1.03] transition duration-300";
  const sizing =
    size === "lg" ? "text-base px-8 py-4" : "text-sm px-6 py-3.5";
  const width = full ? "w-full" : "";
  const cls = `${base} ${sizing} ${width} ${className}`;

  if (isBook) {
    return (
      <a href={CTA_CONFIG.bookHref} data-testid={testId} className={cls}>
        {label}
        <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
      </a>
    );
  }

  return (
    <button type="button" onClick={onEnquire} data-testid={testId} className={cls}>
      {label}
      <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
    </button>
  );
}
